import React, { useEffect, useState } from 'react'
import { logOutApi } from '../../Api/BarestSupplierServices'
import { SalesRepoartApi } from '../../Api/SupplierServices'
import { separate } from '../../Functions/NumberSeprator'
import BarGraph from '../BarGraph/BarGraph'
import LoadingComponet from '../LoadingComponet/LoadingComponet'
import SliderFood from '../Slider/Slider'
import Style from './SalesRepoart.module.css'

const SalesRepoart = () => {
    const[Repoarts,setRepoarts]=useState()
    useEffect(()=>{
       
        getSalesRepoarts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const LogoutHandler=()=>{
        let info={
            logout:""
        }
        logOutApi(info,succ=>{
            console.log(succ)
        })
    }
    const getSalesRepoarts=async()=>{
        const data=await SalesRepoartApi()
        setRepoarts(data)
        if(data.status===-2){
            LogoutHandler()
            console.log("first")
            localStorage.clear()
        }
    }
    let loadingHandler=null
    if(Repoarts===undefined){
        loadingHandler=<LoadingComponet/>
    }
    else{
        loadingHandler=<>
            <h3 style={{fontSize: ".9rem"}}>گزارش فروش روزانه</h3>
                <section className={Style.TodayOrderRepoartHolder}>
                    <div className={Style.TodayOrderRepoartHolder__ReportPart}>
                        <p className={Style.DailyOrderCount}>{Repoarts.daily.count}</p>
                        <h5 style={{fontSize: ".9rem"}}>تعداد سفارش ها</h5>
                    </div>
                    <div className={Style.TodayOrderRepoartHolder__ReportPart}>
                        <p  className={Style.DailyIncome}>{separate(Repoarts.daily.income)}</p>
                        <h5 style={{fontSize: ".9rem"}}>(تومان)مقدار درآمد</h5>
                    </div>
                </section>
                <h3 style={{fontSize: ".9rem"}}>گزارش فروش هفتگی</h3>
                <BarGraph repoarts={Repoarts.weekly}/>
                <h3 style={{fontSize: ".9rem"}}>گزارش فروش براساس دسته بندی</h3>
                <SliderFood list={Repoarts.category}/>
        </>
    }
    return (
        <div className={Style.pageHolder}>
            {
                loadingHandler
            }
        </div>
    )
}

export default SalesRepoart
